var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reader" }, [
    _c(
      "p",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.error,
            expression: "!error"
          }
        ],
        staticClass: "info"
      },
      [
        _vm._v("Lütfen ürünün "),
        _c("strong", [_vm._v("QR kodunu")]),
        _vm._v(" okutunuz.")
      ]
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.error,
            expression: "error"
          }
        ],
        staticClass: "error"
      },
      [_vm._v(_vm._s(_vm.error))]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "scanner" },
      [
        _c("i", { staticClass: "top-left-up" }),
        _vm._v(" "),
        _c("i", { staticClass: "top-left-side" }),
        _vm._v(" "),
        _c("i", { staticClass: "top-right-up" }),
        _vm._v(" "),
        _c("i", { staticClass: "top-right-side" }),
        _vm._v(" "),
        _c("i", { staticClass: "bottom-left-down" }),
        _vm._v(" "),
        _c("i", { staticClass: "bottom-left-side" }),
        _vm._v(" "),
        _c("i", { staticClass: "bottom-right-down" }),
        _vm._v(" "),
        _c("i", { staticClass: "bottom-right-side" }),
        _vm._v(" "),
        _c("qrcode-stream", {
          attrs: { camera: _vm.camera },
          on: { decode: _vm.onDecode, init: _vm.onInit }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.product
      ? _c("div", { staticClass: "popup" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.product.title))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [
            _c("span", [_vm._v(_vm._s(_vm.product.price_title) + ": ")]),
            _c("span", { staticClass: "bordered" }, [
              _vm._v(_vm._s(_vm.product.price))
            ])
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "rescan", on: { click: _vm.reScan } }, [
            _vm._v("Tekrar tara")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b5ad26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b5ad26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./themes/b2b/dev/js/qr/components/Reader.vue
// module id = 77
// module chunks = 3